export const COMPARISON_HEADER_ATTRIBUTE = 'data-comparison-header';
